import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useSelector } from 'react-redux';
import { Portal } from 'styleguide';

import { useSelection } from 'craft/hooks';
import { selectContextMenu } from 'craft/state';

import { MenuBody } from './MenuBody';
import { MenuContainer } from './MenuContainer';
import { useOnCloseMenu } from './useOnCloseMenu';

export const ContextMenu = React.memo(() => {
  const { selection } = useSelection();
  const contextMenu = useSelector(selectContextMenu);
  const onCloseMenu = useOnCloseMenu();

  if (selection.isEmpty || !contextMenu || selection.hasRootNode) {
    return null;
  }
  return (
    <Portal>
      <OutsideClickHandler onOutsideClick={onCloseMenu}>
        <MenuContainer top={contextMenu.clientY} left={contextMenu.clientX}>
          <MenuBody />
        </MenuContainer>
      </OutsideClickHandler>
    </Portal>
  );
});
